import React from 'react'

export const DeviceInfo = React.createContext<DeviceInfo>({
  token: '',
  lang: '',
  gameCode: '',
  env: '',
})
